export const SET_NOT = "SET_NOT";
export const SET_FL = "SET_FL";
export const SET_GALY = "SET_GALY";
export const SET_TAB = "SET_TAB";